// extracted by mini-css-extract-plugin
export default {"overlay":"style_overlay__JVvzc","content":"style_content__apThi","closeBtn":"style_closeBtn__gSU4x"};